import { SubscriptionApi } from '@/services';
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { StripeCheckoutError, StripeCheckoutSuccess } from './subComponents';
export const StripePaymentRedirect = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const sessionId = urlParams.get('session_id') || '';
    const [status, setStatus] = useState('');
    useEffect(() => {
        const checkSessionStatus = async () => {
            try {
                const res = await SubscriptionApi.fetchStripeCheckoutSessionStatus({
                    params: {
                        sessionId,
                    },
                });
                const data = res.data;
                setStatus(data.status);
            }
            catch (error) {
                setStatus('error');
            }
        };
        if (sessionId) {
            checkSessionStatus();
        }
    }, [sessionId]);
    return (React.createElement(React.Fragment, null,
        status === 'open' && React.createElement(Navigate, { to: "/salesWizard" }),
        status === 'complete' && React.createElement(StripeCheckoutSuccess, null),
        status === 'error' && React.createElement(StripeCheckoutError, null)));
};
